import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from 'react-hook-form';
import { CLIENT, TASK, TASKALL, USER } from "../../services/actions";
import React from "react";
import { Button, Container, Box, Grid, Tab, Tabs, Pagination, Avatar, Typography, Card, Stack } from "@mui/material";
import InfoCard from "../extra/InfoCard";
import { BsCheckSquare, BsDashSquare, BsFilePlusFill } from "react-icons/bs";
import RDialog from "../extra/RDialog";
import Form from './Form';
import ActionBar from "../extra/ActionBar";
import ProjectImg from './project.jpg'
import SearchBar from "../extra/SearchBar";
import InfoCard2 from "../extra/InfoCard2";
import { isBase64Image, seedData } from "../../libs/Libs";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";
import { BsCopy } from "react-icons/bs";
import ServiceTaskForm from "./ServiceTaskForm";
import MyCard from "../extra/Card"
import NoData from "../extra/NoData";

export default function View() {
  let dispatch = useDispatch()
  const location = useLocation();
  const { data, prevNav } = location.state || {};
  const [open, setOpen] = React.useState(false)
  const [defV, setDefV] = React.useState({})
  const [view, setView] = React.useState(1);
  const navigate = useNavigate();
  let ref = React.createRef()
  let ref2 = React.createRef()
  let taskState = useSelector((state) => state?.taskState)
  let taskallState = useSelector((state) => state?.taskallState)
  const [companies, setCompanies] = React.useState([])
  let user = useSelector((state) => state?.loginState?.auth)
  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchTasks = (id = 0) => {
    const url = `task/${page}/?filter_by={"service_id":${id}}`; // pass page number
    dispatch({ type: `${TASKALL}_GET`, payload: url });
  };

  React.useEffect(() => {
    try {
      console.log("Company List", user)
      //dispatch({ type: `${PROJECTALL}_GET`, payload: 0 })
      fetchTasks(data?.id);
      // dispatch({ type: `${COMPANY}_GET`, payload: 0 })
    } catch (err) {
    }
  }, [])


  React.useEffect(() => {
    if (taskState?.success) {
      setOpen(!taskState?.success)
      fetchTasks(data?.id);
    }

  }, [taskState?.data])

  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `task/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${TASKALL}_GET`, payload: query });
  };
  const tableHeadings = ["ID", "image", "Project Name", "Company Name", "Country", "Duration", "Camera Count"];
  const tableRows = taskallState?.data?.results?.map((project) => ({
    id: project.id,
    image: project.project_image,
    project_name: project.project_name,
    company_name: project.company_name,
    country: project.country,
    duration: project.duration,
    camera_count: project.camera_count,


  }));

  const handleDelete = (id) => {
    dispatch({ type: `${TASK}_DELETE`, payload: id });
  };

  const transformData = (data) => {
    return {
      id: data.id || 0,
      task_name: data.task_name || "",
      description: data.description || "",
      continuity: data.continuity || null,
      checklist: Array.isArray(data.checklist) ? data.checklist : []
    };
  };

  return (
    <>

      {open ? <div>
        <ServiceTaskForm
          tasks={(taskallState?.data?.results || [])}
          service={data}
          defaultValues={defV}
          onSubmit={(payload) => {
            payload = transformData(payload)
            payload.service = data?.id
            if (!isBase64Image(payload.image)) {
              delete payload["image"]
            }

            let action = payload.id ? `${TASK}_PATCH` : `${TASK}_POST`
            dispatch({ type: action, payload })
          }}
          back={() => { setOpen(false) }}
        /></div>
        : <Container maxWidth="false" className="py-3">
          <Box className="card-bg" sx={{ my: 2, py: 0.2, px: 2, borderRadius: 1 }}>
            <ActionBar
              showGrid={[2, 5]}
              onBtnClick={(type, col) => {
                if (type == "previous") {
                  navigate("/services/")
                }
                if (type === "grid") {
                  setView(1);
                }
                if (type === "tabular") {
                  setView(2);
                }
              }}
              hasPermission={user.permissions.includes('services.add_service')}
              label={[data?.service_name || '', 'Tasks']}
              setOpen={(s) => {
                if (user.main_role == "Company") {
                  setCompanies(user?.companies)
                } else {
                  // dispatch({ type: `${COMPANY}_GET`, payload: 0 })
                }
                setDefV({});
                setOpen(true);

              }}
              btnLabel="ADD TASK"
              btnPrevLabel="Back"
            />
          </Box>
          <SearchBar bylist={["task_name"]} handleSearch={handleSearch} />
          {view === 1 && (
            <>
              {!taskallState?.data?.results || taskallState?.data?.results?.length === 0 ? (
                <NoData title="No Service Tasks Found" message="There are currently no tasks defined for this service. Click 'Add Task' to create one." />
              ) : (
                <>
                  <Grid container spacing={1}>
                    {taskallState?.data?.results?.map((task, idx) => {
                      return <Grid alignItems="stretch" size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>

                        <MyCard
                          title={task.task_name}
                          subtitle={task.client_creation_date}
                          onAction={(action) => {
                            if ("more-info" === action) {
                              navigate("/more-info/", {
                                state: {
                                   data: task,
                                  title: "Service Task",
                                  prevNav: { url: '/services-tasks/', state: { state: { data } } }
                                }
                              })
                            } else if ("edit" === action) {
                              setDefV(task)
                              setOpen(true)
                            } else if ("delete" === action) {
                              handleDelete(task?.id)
                            }

                          }}
                        >
                          <Stack spacing={1.5} sx={{ mt: 1 }}>
                            {/* Continuity Info */}
                            {task?.continuity_task_name && (
                              <Box display="flex" justifyContent="center" alignItems="center" gap={1} sx={{ bgcolor: '#eff6ff', p: 1, borderRadius: 1, border: '1px dashed #bfdbfe' }}>
                                <Typography color="#3b82f6" fontSize={12} fontWeight={600}>Task - 1</Typography>
                                <Typography fontSize={14} color="#60a5fa" title={`${task.task_name} connected to ${task?.continuity_task_name}`}>🔗</Typography>
                                <Typography color="#3b82f6" fontSize={12} fontWeight={600}>{task?.continuity_task_name}</Typography>
                              </Box>
                            )}

                            <Box sx={{ p: 1.5, bgcolor: '#f8fafc', borderRadius: 2, border: '1px solid #f1f5f9' }}>
                              <Typography fontSize={11} color="textSecondary" textTransform="uppercase" letterSpacing={0.5} fontWeight={700} mb={1}>
                                Checklists
                              </Typography>
                              <Stack spacing={0.8}>
                                {(task?.checklist || []).map((c, index) => (
                                  <Box key={index} sx={{ bgcolor: '#ffffff', p: 1, borderRadius: 1, border: '1px solid #e2e8f0' }} display="flex" justifyContent="space-between" alignItems="center">
                                    <Typography fontSize={12} fontWeight={500} color="#334155">{c}</Typography>
                                    {/* <Box sx={{ color: '#ef4444', display: 'flex' }}><BsDashSquare size={14} /></Box> */}
                                  </Box>
                                ))}
                              </Stack>
                            </Box>
                          </Stack>

                          <Box mt={1.5}>
                            <Typography color="#64748b" fontSize={12} lineHeight={1.6} sx={{ display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                              {task.description}
                            </Typography>
                          </Box>
                        </MyCard>
                      </Grid>
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                    <Pagination
                      count={Math.ceil(taskallState?.data?.count / pageSize)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                      color="primary"
                    />
                  </Box>
                </>
              )}
            </>
          )}
          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={(row) => {
                // Find the original project data from the full results
                const originalData = taskallState?.data?.results.find(
                  (project) => project.id === row.id
                );

                // Set the form's default values and open the form
                if (originalData) {
                  setDefV(originalData);
                  setOpen(true);
                }
              }}
              onDelete={handleDelete}
            />
          )}
          {view === 4 && <MoreInfo
            data={{
              ...defV,
              active: defV.active ? "Yes" : "No",
              verify: defV.verify ? "Yes" : "No",
            }}

            skip={['country', 'description', 'error_email', 'no_users', 'owner', 'image']}
            group={['', 'project_name', 'created_at',]}
            icons={{ project_image: <BsCopy /> }}
            css={{ project_image: { color: '#1976d2' } }}
            onClose={() => { setView(1) }} />}

        </Container>}

    </>
  )
}